import { render, staticRenderFns } from "./WsPtCheckbox.vue?vue&type=template&id=d2aba4ee"
import script from "./WsPtCheckbox.vue?vue&type=script&lang=ts"
export * from "./WsPtCheckbox.vue?vue&type=script&lang=ts"
import style0 from "./WsPtCheckbox.vue?vue&type=style&index=0&id=d2aba4ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports